 
<div class="grid-container margin-top v-pad">
    <div class="grid-x">
        <div class="cell small-12">
            <h2 class="h4 bold">Log In to RICS</h2>
        </div>
    </div>
</div>

